<template>
  <v-list nav dense>
    <!-- <v-list-item-group> -->
    <v-list-item to="/" color="primary">
      <v-list-item-icon>
        <v-icon>mdi-view-dashboard</v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        <v-list-item-title>Dashboard</v-list-item-title>
      </v-list-item-content>
    </v-list-item>

    <v-list-group no-action prepend-icon="person" group="cadastros">
      <template v-slot:activator>
        <v-list-item-content>
          <v-list-item-title>Cadastros</v-list-item-title>
        </v-list-item-content>
      </template>

      <v-list-item :to="{ name: 'ClientesLista' }" v-show="$auth.can('clientes:acessar')">
        <v-list-item-content>
          <v-list-item-title>Clientes</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item :to="{ name: 'FornecedoresLista' }" v-show="$auth.can('fornecedores:acessar')">
        <v-list-item-content>
          <v-list-item-title>Fornecedores</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item :to="{ name: 'VendedoresLista' }" v-show="$auth.can('vendedores:acessar')">
        <v-list-item-content>
          <v-list-item-title>Vendedores</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list-group>

    <v-list-group no-action prepend-icon="card_travel" group="catalogo">
      <template v-slot:activator>
        <v-list-item-content>
          <v-list-item-title>Produtos</v-list-item-title>
        </v-list-item-content>
      </template>
      <v-divider></v-divider>
      <v-list-item :to="{ name: 'ProdutosLista' }" v-show="$auth.can('produtos:acessar')">
        <v-list-item-content>
          <v-list-item-title>Cadastro de Produtos</v-list-item-title>
        </v-list-item-content>
        <!-- <v-list-item-action>
          <v-chip color="primary lighten-2" x-small>{{$store.state.dashboard.dashboard.produtos}}</v-chip>
        </v-list-item-action> -->
      </v-list-item>

      <v-list-item :to="{ name: 'ControleProdutos' }" v-show="$auth.can('controle_produtos:acessar')">
        <v-list-item-content>
          <v-list-item-title>Controle de Produtos</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item :to="{ name: 'PedidosCompraLista' }" v-show="$auth.can('pedidoscompra:acessar')">
        <v-list-item-content>
          <v-list-item-title>Pedido de Compra</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item :to="{ name: 'EstoqueLista' }" v-show="$auth.can('movimentoestoque:acessar')">
        <v-list-item-content>
          <v-list-item-title>Movimento de Estoque</v-list-item-title>
        </v-list-item-content>
      </v-list-item>


      <v-list-item :to="{ name: 'EtiquetasProdutos' }" v-show="$auth.can('etiquetas:acessar')">
        <v-list-item-content>
          <v-list-item-title>Etiquetas</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item :to="{ name: 'BalancoLista' }" v-show="$auth.can('balanco:acessar')">
        <v-list-item-content>
          <v-list-item-title>Balanço</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item :to="{ name: 'ProdutosGrupos' }" v-show="$auth.can('grupos_produtos:acessar')">
        <v-list-item-content>
          <v-list-item-title>Grupos de Produtos</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item :to="{ name: 'VariacoesLista' }" v-show="$auth.can('variacoes:acessar')" >
        <v-list-item-content>
          <v-list-item-title>Variações/Grades</v-list-item-title>
        </v-list-item-content>
      </v-list-item>


      <!-- <v-list-item :to="{ name: 'LotesLista' }" v-show="$auth.can('lotes_acessar')">
        <v-list-item-content>
          <v-list-item-title>Lotes</v-list-item-title>
        </v-list-item-content>
      </v-list-item> -->
      
    </v-list-group>

    <v-list-group no-action prepend-icon="shopping_cart" group="vendas">
      <template v-slot:activator>
        <v-list-item-content>
          <v-list-item-title>Vendas</v-list-item-title>
        </v-list-item-content>
      </template>
      <!-- <v-list-item to="/i/Orçamentos">
          <v-list-item-content>
            <v-list-item-title>Orçamentos</v-list-item-title>
          </v-list-item-content>
      </v-list-item> -->
      <v-list-item :to="{ name: 'PedidosLista' }" v-show="$auth.can('pedidos:acessar')">
        <v-list-item-content>
          <v-list-item-title>Pedidos</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <!-- <v-list-item to="/i/Comissões">
          <v-list-item-content>
            <v-list-item-title>Comissões</v-list-item-title>
          </v-list-item-content>
      </v-list-item> -->
      <v-list-item to="/i/Devoluções" disabled>
        <v-list-item-content>
          <v-list-item-title>Devoluções</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <!-- <v-list-item to="/i/Tipos de Pagamentos">
          <v-list-item-content>
            <v-list-item-title>Tipos de Pagamentos</v-list-item-title>
          </v-list-item-content>
      </v-list-item> -->
    </v-list-group>

    <!-- <v-list-group no-action prepend-icon="check_circle" group="compras">
      <v-list-item slot="activator">
          <v-list-item-content>
            <v-list-item-title>Compras</v-list-item-title>
          </v-list-item-content>
      </v-list-item>
      <v-list-item to="/i/Orçamentos">
          <v-list-item-content>
            <v-list-item-title>Orçamentos</v-list-item-title>
          </v-list-item-content>
      </v-list-item>
      <v-list-item to="/i/Pedidos">
          <v-list-item-content>
            <v-list-item-title>Pedidos</v-list-item-title>
          </v-list-item-content>
      </v-list-item>
      <v-list-item to="/i/Devoluções">
          <v-list-item-content>
            <v-list-item-title>Devoluções</v-list-item-title>
          </v-list-item-content>
      </v-list-item>
      <v-list-item to="/i/Central de Compras">
          <v-list-item-content>
            <v-list-item-title>Central de Compras</v-list-item-title>
          </v-list-item-content>
      </v-list-item>
      <v-list-item to="/i/Estoque">
          <v-list-item-content>
            <v-list-item-title>Estoque</v-list-item-title>
          </v-list-item-content>
      </v-list-item>
      <v-list-item to="/i/Tipos de Pagamentos">
          <v-list-item-content>
            <v-list-item-title>Tipos de Pagamentos</v-list-item-title>
          </v-list-item-content>
      </v-list-item>
    </v-list-group> -->

    <v-list-group no-action prepend-icon="note" group="cheques">
      <template v-slot:activator>
        <v-list-item-content>
          <v-list-item-title>Cheques</v-list-item-title>
        </v-list-item-content>
      </template>
      <v-list-item :to="{ name: 'ChequesLista' }" v-show="$auth.can('cheques:acessar')">
        <v-list-item-content>
          <v-list-item-title>Controle de Cheques</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item to="{ name: 'RemessaCheques' }" disabled>
        <v-list-item-content>
          <v-list-item-title>Remessa de Cheques</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list-group>

    <v-list-group no-action prepend-icon="monetization_on" group="financeiro">
      <template v-slot:activator>
        <v-list-item-content>
          <v-list-item-title>Financeiro</v-list-item-title>
        </v-list-item-content>
      </template>
      <v-list-item :to="{ name: 'ExtratoCliente' }" v-show="$auth.can('extrato:acessar')">
        <v-list-item-content>
          <v-list-item-title>Extrato do Cliente</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      
      <v-list-item :to="{ name: 'ExtratoFornecedor' }" v-show="$auth.can('extratofornecedor:acessar')">
        <v-list-item-content>
          <v-list-item-title>Extrato do Fornecedor</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item :to="{ name: 'ContasAReceberLista' }" v-show="$auth.can('contasrecerber:acessar')">
        <v-list-item-content>
          <v-list-item-title>Contas a Receber</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item :to="{ name: 'ContasPagarLista' }" v-show="$auth.can('contaspagar:acessar')">
        <v-list-item-content>
          <v-list-item-title>Contas a Pagar</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item :to="{ name: 'RecebimentosLista' }" v-show="$auth.can('recebimentos:acessar')">
        <v-list-item-content>
          <v-list-item-title>Recebimentos</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item :to="{ name: 'CaixaLista' }" v-show="$auth.can('caixa:acessar')">
        <v-list-item-content>
          <v-list-item-title>Caixa</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <!-- <v-list-item to="/i/Movimentação de Caixa">
          <v-list-item-content>
            <v-list-item-title>Movimentação de Caixa</v-list-item-title>
          </v-list-item-content>
      </v-list-item> -->
      <!-- <v-list-item to="/financeiro/contasareceber">
          <v-list-item-content>
            <v-list-item-title>Contas a Receber</v-list-item-title>
          </v-list-item-content>
      </v-list-item> -->

      <v-list-item :to="{ name: 'CategoriasLista' }" v-show="$auth.can('categorias:acessar')">
        <v-list-item-content>
          <v-list-item-title>Categorias Contas</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <!-- <v-list-item to="/i/Faturamento">
          <v-list-item-content>
            <v-list-item-title>Faturamento</v-list-item-title>
          </v-list-item-content>
      </v-list-item>
      <v-list-item to="/i/Conta Corrente">
          <v-list-item-content>
            <v-list-item-title>Conta Corrente</v-list-item-title>
          </v-list-item-content>
      </v-list-item>
      <v-list-item to="/i/Conta Gerencial">
          <v-list-item-content>
            <v-list-item-title>Conta Gerencial</v-list-item-title>
          </v-list-item-content>
      </v-list-item> -->
    </v-list-group>

    <v-list-item :to="{ name: 'Relatorios' }" color="primary" v-show="$auth.can('relatorios')">
      <v-list-item-action>
        <v-icon>assignment</v-icon>
      </v-list-item-action>
      <v-list-item-content>
        <v-list-item-title>Relatórios</v-list-item-title>
      </v-list-item-content>
    </v-list-item>

    <v-divider></v-divider>

    <v-list-group no-action prepend-icon="settings" group="sistema">

      <template v-slot:activator>
        <v-list-item-content>
          <v-list-item-title>Sistema</v-list-item-title>
        </v-list-item-content>
      </template>

      <v-list-item :to="{name: 'UsuariosLista'}" v-show="$auth.can('usuarios:acessar')">
        <v-list-item-content>
          <v-list-item-title>Usuários</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item :to="{name: 'UsuariosPermissoes'}" v-show="$auth.can('permissoes:acessar')">
        <v-list-item-content>
          <v-list-item-title>Permissões</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item v-if="config.USAR_SISTEMA_MULTI_LOJAS" :to="{name: 'LojasLista'}" v-show="$auth.can('lojas:acessar')">
        <v-list-item-content>
          <v-list-item-title>Lojas</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item :to="{name: 'Configuracoes'}" v-if="$auth.isAdmin() && !$config.IS_PRODUCTION">
        <v-list-item-content>
          <v-list-item-title>Configurações Internas</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <!-- <v-list-item :to="{name: 'ConfiguracoesSistema'}" v-show="$auth.can('configuracoes:acessar')">
        <v-list-item-content>
          <v-list-item-title>Configurações</v-list-item-title>
        </v-list-item-content>
      </v-list-item> -->

      <v-list-item :to="{name: 'Whatsapp'}" v-show="$auth.can('whatsapp:acessar')">
        <v-list-item-content>
          <v-list-item-title>Whatsapp</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

    </v-list-group>
    <!-- </v-list-item-group> -->
  </v-list>
</template>

<script>
export default {
  props: {
    miniVariant: {
      type: Boolean,
    },
  },

  methods: {
    sair() {
      setTimeout(() => {
        this.$auth.logout();
        this.$router.push("/login");
      }, 1000);
    },
  },

  computed: {
    config() {
      return this.$store.state.configuracoes;
    }
  },
};
</script>

<style scoped></style>
